import React from "react";
import {TimePicker as MuiTimePicker} from "@mui/x-date-pickers";
import {TextFieldBase} from "../textfield/TextFieldBase";

interface TimePickerFieldProps<TInputDate, TDate = TInputDate> {
    label: string;
    value: TInputDate | null | undefined;
    onChange: (value: TDate | null) => void;
    required?: boolean;
    readOnly?: boolean;
    disabled?: boolean;
    error?: string;
    helperText?: string;
}

export function TimePicker<TInputDate, TDate = TInputDate>(props: Readonly<TimePickerFieldProps<TInputDate, TDate>>) {
    const {label, value, onChange, required, readOnly, disabled, error, helperText} = props;

    return (
        <MuiTimePicker
                label={label}
                value={value}
                onChange={onChange}
                disabled={disabled}
                readOnly={readOnly}
                renderInput={(params) => <TextFieldBase {...params}
                        error={!!error}
                        helperText={error ?? helperText}
                        required={required}
                        readOnly={readOnly}
                        inputProps={{
                            ...params.inputProps,
                            placeholder: readOnly ? "" : params.inputProps?.placeholder
                        }}/>
                }/>
    );
}
